import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Contact from './Contact'

ReactDOM.render(
  <BrowserRouter>
  <Switch>
      <Route path="/" exact={true} component={App} />
      <Route path="/contact" component={Contact} />
  </Switch>
</ BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
